import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'jotai';
import { setPlatformRef, PlatformProvider } from '@localagent/platform';
import { App, installWebRuntimeKeys, store } from '@localagent/app-shell';
import {
  browserWebArmSources,
  declaredWebRuntimeConfigUrl,
  loadWebRuntimeConfig,
} from '@localagent/sdk';
import { WebPlatform } from './platform';
import '@/styles/globals.css';

// (la ADR-d43ea)
async function boot(root: HTMLElement): Promise<void> {
  const runtimeConfigUrl = declaredWebRuntimeConfigUrl(browserWebArmSources());
  if (runtimeConfigUrl !== null) {
    installWebRuntimeKeys(await loadWebRuntimeConfig(runtimeConfigUrl));
  }

  const webPlatform = new WebPlatform();
  setPlatformRef(webPlatform);

  ReactDOM.createRoot(root).render(
    <React.StrictMode>
      <PlatformProvider platform={webPlatform}>
        <Provider store={store}>
          <App />
        </Provider>
      </PlatformProvider>
    </React.StrictMode>
  );
}

const root = document.getElementById('root')!;
boot(root).catch((error: unknown) => {
  root.textContent = `ShogunChop could not start: ${error instanceof Error ? error.message : String(error)}`;
  throw error;
});
